import { InitNewGamePage } from './NewGame.js';
import { InitLocalization, Localization } from './Localization.js';

const TabsContent = [
    ['#nav-kolya-sasha-tab', '#kolya-sasha-content', 'KolyaSasha.html'],
    ['#nav-vova-denis-tab', '#vova-denis-content', 'VovaDenis.html'],
    ['#nav-points-tab', '#points-content', 'Points.html'],
    ['#nav-new-game-tab', '#new-game-content', 'NewGame.html', InitNewGamePage]
];

function setTabClickHandlers()
{
    for (const entry of TabsContent)
    {
        $(entry[0] as string).on('click', function (e)
        {
            e.preventDefault();
            // @ts-ignore: Suppress TS2339 as 'tab' is a jQuery plugin method (Bootstrap)
            ($(e.target) as any).tab('show');
            $('.nav-content').prop('hidden', true);
            $(entry[1] as string).prop('hidden', false);
        });
    }
}

async function loadBuildNumber()
{
    let fetchResult: Response = await fetch(`/webbuild_number.txt`);
    let build = await fetchResult.text();
    let siteBuild = Localization.BuildNumber.replace('{build}', build);
    $('#build-number').text(siteBuild);
}

async function loadContent()
{
    for (const entry of TabsContent)
    {
        let content = await fetch(entry[2] as string);
        if (!content.ok)
        {
            console.error(`Failed to load content from ${entry[2]}`);
            continue;
        }
        $(entry[1] as string).html(await content.text());
        if (entry.length > 3)
            (entry[3] as () => void)();
    }
}

document.addEventListener('DOMContentLoaded', async function ()
{
    await InitLocalization();
    loadBuildNumber();
    loadContent();
    setTabClickHandlers();
});
